import axios from 'axios'
import {BASE_URL} from './ConnectionConfig'
import HandleRequestError from './HandleRequestError'

let axiosAuth = axios.create({
  baseURL: BASE_URL
})

axiosAuth.interceptors.response.use(response => response, err => HandleRequestError(err))

const injectToken = () => {
  Object.assign(axiosAuth.defaults, {headers: {'x-access-token': window.localStorage.getItem('token')}})
}

const check = {
  get: (obj, prop, value) => {
    injectToken()
    return obj[prop]
  },
  post: (obj, prop, value) => {
    injectToken()
    return obj[prop]
  },
  delete: (obj, prop, value) => {
    injectToken()
    return obj[prop]
  },
  put: (obj, prop, value) => {
    injectToken()
    return obj[prop]
  },
  patch: (obj, prop, value) => {
    injectToken()
    return obj[prop]
  }
}

let axiosWithHeader = new Proxy(axiosAuth, check)

export default axiosWithHeader



// WEBPACK FOOTER //
// ./src/communication/AuthConnection.js